/* Nilo V5.13.84: Strict same-family recommendations; price ranks only eligible products.
 * Restores V5.13.46 category/gender guarantees after V5.13.80/81 price changes.
 * Nilo V5.13.46: Single authoritative product recommender.
 * Item type + customer segment are checked BEFORE any card is inserted.
 * Four balanced shelves + a genuinely bootstrapped infinite discovery grid.
 * Never use a general all-products fallback without category verification. */
(function(){
 'use strict';
 if(window.__niloV51346Recommendations)return;
 window.__niloV51346Recommendations=true;
 var core=window.NiloCatalogueCore, merch=window.NiloMerchV51341;
 var aliases={
  set:['ensemble','ensembles','طقم','أطقم'], dress:['robe','robes','dress','فستان','فساتين'],
  abaya:['abaya','abayas','عباية','عبايات'],caftan:['caftan','kaftan','قفطان'],
  takchita:['takchita','تكشيطة'],jellaba:['jellaba','djellaba','جلابة'],
  pyjama_home:['pyjama','pijama','بيجامة'],sport_set:['survetement','survêtement','jogging','tracksuit'],
  swim:['burkini','بوركيني'],hijab:['hijab','khimar','foulard','حجاب'],
  shoe:['chaussure','chaussures','sandale','basket','حذاء'],bag:['sac','pochette','حقيبة'],
  shirt:['chemise','قميص'],skirt:['jupe','تنورة'],accessory:['accessoire','bijou','إكسسوارات']
 };
 var tags={set:'collection-ensembles',dress:'collection-robes',abaya:'collection-abayas',
  caftan:'collection-caftans',takchita:'collection-takchitas',jellaba:'collection-jellabas',
  pyjama_home:'collection-pyjamas',sport_set:'collection-survetements',swim:'collection-burkinis',
  hijab:'collection-hijabs',shoe:'collection-chaussures',bag:'collection-sacs',
  shirt:'collection-chemises',skirt:'collection-jupes',accessory:'collection-accessoires'};
 function one(sel,scope){return(scope||document).querySelector(sel);}
 function all(sel,scope){return Array.from((scope||document).querySelectorAll(sel));}
 function norm(x){return core&&core.norm?core.norm(x):String(x||'').toLowerCase();}
 function handle(card){return String(card&&card.dataset.niloProductHandle||'');}
 function titleMode(str){
  var f=core.titleFlags(str);
  if(f.swim)return'swim';if(f.pyjama)return'pyjama_home';if(f.sport)return'sport_set';
  if(f.takchita)return'takchita';if(f.caftan)return'caftan';if(f.jellaba)return'jellaba';
  if(f.abaya)return'abaya';
  // Some supplier titles mention both "robe" and "ensemble". Use the first
  // actual garment noun so "Robe ... ensemble" remains a dress while
  // "Ensemble ... robe" remains a set; do not let a cheaper other category win.
  if(f.dress&&f.set){
   var normalized=norm(str),robePos=normalized.search(/\brobes?\b|\bdresses?\b|فستان|فساتين/),setPos=normalized.search(/\bensembles?\b|\bsets?\b|طقم|أطقم/);
   return robePos>=0&&(setPos<0||robePos<setPos)?'dress':'set';
  }
  if(f.set)return'set';if(f.dress)return'dress';
  if(f.hijab)return'hijab';if(f.shoe)return'shoe';if(f.bag)return'bag';
  if(f.shirt)return'shirt';if(f.skirt)return'skirt';if(f.accessory)return'accessory';
  return'';
 }
 // Explicit gender in the TITLE has priority over any supplier tags.
 // Plural "hommes", "masculin", "garçons", and Moroccan Arabic are significant.
 function titleGender(t){
  t=norm(t);
  if(/\bfemmes?\b|\bwomen\b|\bwoman\b|\bfeminine?\b|نسائي|نسائية|للسيدات|للنساء/.test(t))return'women';
  if(/\bhommes?\b|\bmens?\b|\bmasculin\b|\bmale\b|رجالي|رجال|للرجال/.test(t))return'men';
  if(/\benfants?\b|\bkids?\b|\bgarcons?\b|\bgarçons?\b|\bfilles?\b|\bboys?\b|\bgirls?\b|اطفال|أطفال|بنات|اولاد|أولاد/.test(t))return'kids';
  return'';
 }
 function taggedGender(tax){
  var text=norm(tax||'');
  if(/(?:genre|cat|collection|subcat):\s*(?:homme|hommes|men|masculin)/.test(text))return'men';
  if(/(?:genre|cat|collection|subcat):\s*(?:enfant|enfants|kids|garcon|fille)/.test(text))return'kids';
  if(/(?:genre|cat|collection|subcat):\s*(?:femme|femmes|women)/.test(text))return'women';
  return'';
 }
 function genderOf(card){
  var title=titleGender(card.dataset.niloTitle||'');
  if(title)return title;
  var marked=taggedGender(card.dataset.niloTaxonomy||'');
  return marked||String(card.dataset.niloGender||'unknown');
 }
 function unknownTerm(text){
  var stop=/^(femme|femmes|homme|hommes|pour|avec|sans|le|la|les|des|de|du|un|une|en|et|the|longue|long|court|courte|unis|uni|nouveau|nouvelle|modele|modeles|taille|couleur)$/;
  return norm(text).replace(/[^a-z0-9\u0600-\u06ff ]/g,' ').split(/\s+/).find(function(w){return w.length>=3&&!stop.test(w);})||'';
 }
 function start(){
  var scope=one('[data-nilo-v51346-recommendations]');
  if(!scope||!core||!merch||!window.fetch||!window.DOMParser)return;
  var pageTitle=scope.dataset.niloRelatedTitle||'',productType=scope.dataset.niloRelatedType||'',seed=scope.dataset.niloRelatedMode||'';
  // Product name is authoritative; a generic home-section or cheap-product tier
  // can never replace the selected product's actual clothing family.
  var mode=titleMode(pageTitle)||titleMode(productType)||(aliases[seed]?seed:'');
  var gender=titleGender(pageTitle)||scope.dataset.niloRelatedGender||'women';
  var term=mode?'':unknownTerm(pageTitle)||unknownTerm(productType)||unknownTerm(scope.dataset.niloRelatedTerm||'');
  var words=mode?(aliases[mode]||[]):[term];
  var queryWords=[];
  var genderWord=gender==='women'?'femme':gender==='men'?'homme':gender==='kids'?'enfant':'';
  if(words[0]&&genderWord)queryWords.push(words[0]+' '+genderWord);
  words.slice(0,4).forEach(function(w){if(w&&queryWords.indexOf(w)<0)queryWords.push(w);});
  if(!queryWords.length&&term)queryWords.push(term);
  var except=scope.dataset.niloRelatedExclude||'';
  var shelves=all('[data-nilo-v51343-reco-rail]',scope);
  var area=one('.nilo-v51343-reco-continuation',scope),grid=one('[data-nilo-v51342-related-items]',scope);
  var sentinel=one('[data-nilo-v51342-related-sentinel]',scope);
  var pools=new Map(),used=new Set([except]),displayed=new Set([except]),lastFamilies=[],queryPages=new Map();
  var working=false,initialized=false,remainingRetries=2,cycle=0,run=0,failures=0,observer=null,collectionPages=1,collectionCursor=1;
  var frag=document.createElement('div');
  var base=new URL((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/',location.origin);
  function eligible(card){
   if(!card||!handle(card)||handle(card)===except||card.dataset.niloAvailable==='0')return false;
   var img=one('.nilo-product-card__media img',card);
   if(!img||!(img.getAttribute('src')||img.getAttribute('srcset')))return false;
   var targetGender=genderOf(card);
   // An explicit opposite gender always excludes a suggestion.
   if(targetGender&&targetGender!=='unknown'&&targetGender!==gender)return false;
   var text=card.dataset.niloTitle||'';
   if(mode){
    var declared=titleMode(text),tax=card.dataset.niloTaxonomy||'';
    // Never let a lower price make a handbag, an accessory or a different
    // garment category eligible for a robe/pyjama/ensemble recommendation.
    if(declared&&declared!==mode)return false;
    if(window.NiloClothingPriorityV51381 &&
       window.NiloClothingPriorityV51381.cardTier(card)===2 &&
       ['bag','shoe','hijab','accessory'].indexOf(mode)<0)return false;
    // The existing V5.13.39 catalogue matcher knows the explicit Shopify
    // collection/type tags, as well as the title fallback when tags are absent.
    return !!core.matches&&core.matches({title:text,taxonomy:tax,available:true},mode);
   }
   // Unknown product family: never replace the original keyword match with
   // a generic "all clothing, cheapest first" fallback.
   var n=norm(text);
   return !!term&&(n.split(/[^a-z0-9\u0600-\u06ff]+/).indexOf(term)!==-1||(term.length>=5&&n.indexOf(term)!==-1));
  }
  function family(card){return merch.family(card)||core.familyKey(card.dataset.niloTitle||'');}
  function parse(cards){return(cards||[]).map(function(s){frag.innerHTML=s;var c=one('.nilo-product-card',frag);return c?c.cloneNode(true):null;}).filter(Boolean);}
  function remember(cards){cards.forEach(function(c){if(eligible(c)&&!pools.has(handle(c))){pools.set(handle(c),c.cloneNode(true));}});
   // Keep memory bounded even for a long shopping session.
   if(pools.size>360){Array.from(pools.keys()).forEach(function(k){if(pools.size>300&&displayed.has(k))pools.delete(k);});}
  }
  function random(a){a=a.slice();for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1)),c=a[i];a[i]=a[j];a[j]=c;}return a;}
  function arrange(cards){
   // Filtering happens FIRST in eligible(), then actual Shopify price. The
   // mixed-home clothing ranking must not act as a product-page recommender.
   var priceAPI=window.NiloPricePriorityV51380;
   var ranked=priceAPI&&priceAPI.cards?priceAPI.cards(cards.filter(eligible)):cards.filter(eligible);
   var list=[],history=lastFamilies.slice(-10),maxPriceGap=3000;
   while(ranked.length){
    // Respect the existing anti-clone spacing without placing a 350-DH item
    // before a different 140-DH model simply to avoid a repeated family.
    var cheapest=priceAPI&&priceAPI.cardPrice?priceAPI.cardPrice(ranked[0]):Infinity;
    var i=ranked.findIndex(function(c){
     return (!priceAPI||priceAPI.cardPrice(c)<=cheapest+maxPriceGap)&&history.slice(-8).indexOf(family(c))===-1;
    });
    if(i<0)i=ranked.findIndex(function(c){
     return (!priceAPI||priceAPI.cardPrice(c)<=cheapest+maxPriceGap)&&history.slice(-3).indexOf(family(c))===-1;
    });
    if(i<0)i=0;
    var c=ranked.splice(i,1)[0];list.push(c);history.push(family(c));history=history.slice(-10);
   }
   return list;
  }
  function take(count){
   var options=arrange(Array.from(pools.values()).filter(function(c){return !used.has(handle(c));})),arr=[];
   options.forEach(function(c){if(arr.length<count&&eligible(c)&&!used.has(handle(c))){
    used.add(handle(c));displayed.add(handle(c));arr.push(c);lastFamilies.push(family(c));
   }});lastFamilies=lastFamilies.slice(-10);return arr;
  }
  function append(host,count){if(!host)return 0;var items=take(count);items.forEach(function(c){host.appendChild(c.cloneNode(true));});return items.length;}
  function refresh(){
   var count=0;shelves.forEach(function(s){var host=one('[data-nilo-v51343-reco-items]',s);var n=host?all('.nilo-product-card',host).length:0;s.hidden=!n;count+=n;});
   var gridCount=grid?all('.nilo-product-card',grid).length:0;
   if(area)area.hidden=!gridCount;
   scope.hidden=!count&&!gridCount;
   return count+gridCount;
  }
  // Spread limited inventory across shelves FIRST instead of filling one shelf to 8
  // and leaving the other three empty. Existing Shopify-rendered cards survive errors.
  shelves.forEach(function(s){var host=one('[data-nilo-v51343-reco-items]',s);if(!host)return;
   remember(all('.nilo-product-card',host));host.replaceChildren();
  });
  function fillShelves(){
   var hosts=shelves.map(function(s){return one('[data-nilo-v51343-reco-items]',s);}).filter(Boolean);
   for(var round=0;round<8;round++){
    var progress=false;
    hosts.forEach(function(h){if(all('.nilo-product-card',h).length<=round&&append(h,1))progress=true;});
    // Allow later calls to fill partially seeded rails without emptying them.
   }
   return refresh();
  }
  fillShelves();
  async function search(word,page){
   var u=new URL('search',base);u.searchParams.set('q',word);u.searchParams.set('type','product');
   u.searchParams.set('page',String(page));u.searchParams.set('sort_by','price-ascending');u.searchParams.set('section_id','nilo-product-reco-search-v51344');
   var r=await fetch(u.href,{credentials:'same-origin',headers:{Accept:'text/html'}});
   if(!r.ok)throw Error('Recherche HTTP '+r.status);
   var doc=new DOMParser().parseFromString(await r.text(),'text/html'),host=one('[data-nilo-v51344-search-feed]',doc);
   if(!host)throw Error('Flux recherche absent');
   return{pages:Math.max(1,Number(host.dataset.niloPages)||1),cards:all('.nilo-product-card',host).map(function(c){return c.outerHTML;})};
  }
  async function searchMore(word){
   var seen=queryPages.get(word)||{total:1,visited:new Set()};var page=1;
   if(seen.visited.has(1)){
    var available=[];for(var j=2;j<=Math.min(seen.total,100);j++)if(!seen.visited.has(j))available.push(j);
    if(!available.length){seen.visited.clear();page=1;}else page=available[Math.floor(Math.random()*available.length)];
   }
   seen.visited.add(page);
   try{var result=await search(word,page);seen.total=Math.max(1,result.pages);queryPages.set(word,seen);remember(parse(result.cards));return true;}
   catch(err){queryPages.set(word,seen);return false;}
  }
  async function collectionMore(){
   if(!mode)return false;
   var raw=scope.dataset.niloRelatedFeed||'';
   // Liquid knows which actual Shopify collection this product belongs to.
   // If missing, keep the existing tag-specific route, never an unfiltered visual fallback.
   if(!raw||!/\/collections\//.test(raw))raw=new URL('collections/all/'+(tags[mode]||''),base).href;
   try{
    var src=merch.source(raw);var index=collectionCursor;
    if(collectionPages>1){if(collectionCursor===1)index=1;else index=1+Math.floor(Math.random()*collectionPages);}
    var result=await merch.fetchPage(src,index);collectionPages=Math.max(1,Number(result.pages)||1);
    collectionCursor++;remember(parse(result.cards));return true;
   }catch(e){return false;}
  }
  async function loadBatch(batch){
   var old=pools.size;
   for(var i=0;i<batch;i++){
    var word=queryWords[(run++)%Math.max(1,queryWords.length)];
    if(word)await searchMore(word);
    if(pools.size-old>=36)break;
    if(i%2===1&&mode)await collectionMore();
   }
   if(pools.size===old&&mode)await collectionMore();
   return pools.size-old;
  }
  function renew(){
   // A new cycle is intentionally allowed when the category's eligible
   // catalogue is exhausted. Prefer not to repeat the last visible cards.
   if(!pools.size)return;
   cycle++;used=new Set([except]);
   var keep=Array.from(displayed).slice(-Math.min(35,Math.floor(pools.size/2)));
   keep.forEach(function(k){used.add(k);});
   // Small catalogues must still loop rather than stopping permanently.
   if(!Array.from(pools.keys()).some(function(k){return !used.has(k);}))used=new Set([except]);
  }
  async function more(){
   if(working||!initialized||!grid)return;working=true;
   try{
    var added=append(grid,16);
    if(added<8){await loadBatch(2);added+=append(grid,16-added);}
    if(!added&&pools.size){renew();append(grid,12);}
    refresh();
   }finally{working=false;}
  }
  function watch(){
   if(!sentinel)return;
   if('IntersectionObserver' in window){
    observer=new IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting;}))more();},{rootMargin:'650px 0px'});
    observer.observe(sentinel);
   }else{
    var onScroll=function(){if(working||!area||area.hidden)return;var r=sentinel.getBoundingClientRect();if(r.top<innerHeight+650)more();};
    addEventListener('scroll',onScroll,{passive:true});
   }
  }
  async function bootstrap(){
   // Trigger discovery even if Shopify rendered ZERO SSR suggestions.
   // Only replace fallback rails after validating at least one eligible item.
   try{await loadBatch(5);
    if(pools.size<Math.max(50,used.size+16)){await loadBatch(4);}
    if(pools.size){
     shelves.forEach(function(s){var h=one('[data-nilo-v51343-reco-items]',s);if(h)h.replaceChildren();});
     used=new Set([except]);displayed=new Set([except]);lastFamilies=[];
     fillShelves();append(grid,12);
    }
    refresh();
   }catch(e){refresh();}
   initialized=true;watch();
   if(scope.hidden&&remainingRetries){
    var retry=function(){if(!scope.hidden||!remainingRetries)return;
     remainingRetries--;loadBatch(3).then(function(){fillShelves();append(grid,12);refresh();});};
    document.addEventListener('visibilitychange',function(){if(!document.hidden)retry();});
    window.addEventListener('online',retry);
   }
  }
  var recent=one('[data-nilo-recently-viewed]');if(recent)recent.hidden=true;
  bootstrap();
  window.NiloProductRecommendationsV51346={mode:mode,gender:gender,verify:eligible,refresh:refresh,more:more,
   titleGender:titleGender,genderOf:genderOf};
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
